import React from 'react';
import styles from './APropos.module.scss';
import photoCliente from '../../Assets/images/garde-enfant-acceuil.jpg';
import { SERVICE_RADIUS_KM } from '../../config/serviceArea';
import SapBadge from '../SapBadge/SapBadge';


const APropos = () => {
  return (
    <section className={styles.aPropos} id="a-propos">
      <div className={styles.container}>
        <div className={styles.photoContainer}>
          <img src={photoCliente} alt="Votre nom" className={styles.photo} />
        </div>
        <div className={styles.textContainer}>
          <h1>Garde d'enfants d'urgence à Éragny<br /><span>votre solution rapide pour des moments imprévus !</span></h1>
          <p>
            Je vous propose mes services de remplacement d'urgence pour les entreprises sap et les particuliers employeurs <strong>à Éragny et aux alentours ({SERVICE_RADIUS_KM} km)</strong>
          </p>
          <p className={styles.infoBanner}>
            En plus des remplacements d'urgence, Nounou Chou Express propose aussi des
            {' '}<a href="#contrat-longue-duree">contrats de garde de longue durée</a>.
            Organisme de services à la personne.
          </p>
          <p>
            Je m'adapte aux besoins spécifiques de chaque famille pour offrir un service   
            <strong> personnalisé</strong> et de <strong>qualité.</strong> Votre tranquillité d'esprit et le bonheur de vos 
            enfants sont <strong>ma priorité.</strong>
          </p>
          <SapBadge className={styles.sapBadge} />
        </div>
      </div>
    </section>
  );
};

export default APropos;